import { Component, inject } from '@angular/core';
import { FolderSpecialistRecordsPageStore } from './folder-specialist-records-page.store';
import {
    SpecialistRecordListComponent
} from '../../../components/services/specialist-record-list/specialist-record-list.component';

@Component({
    selector: 'app-folder-specialist-records-page',
    templateUrl: './folder-specialist-records-page.component.html',
    styleUrls: ['./folder-specialist-records-page.component.scss'],
    providers: [FolderSpecialistRecordsPageStore],
    imports: [
        SpecialistRecordListComponent,
    ],
})
export class FolderSpecialistRecordsPageComponent {
    protected readonly store = inject(FolderSpecialistRecordsPageStore);


}
